import axios from "axios";
import moment from 'moment';

import {
  createAccountQuery,
  createQBLoginQuery,
  deleteQBLoginQuery,
  getQBLoginByCompanyQuery,
  getQBLoginQuery,
  updateQBLoginQuery,
  updateAccountQuery,
  updateAccountActivityQuery,
  updateQBCompanySettings,
  getAccountQuery,
  updateDiscountQuery
} from "./queries.js";

const url =
  "https://3zlkxzydanbwvemxerkgcm3nzu.appsync-api.us-east-1.amazonaws.com/graphql";

const FETCH_DATA_REST_API = "https://0ty5hxkwcb.execute-api.us-east-1.amazonaws.com/default/funcHandleFetchDataRequest-dev";
const FETCH_DATA_TEST_REST_API = "https://0ty5hxkwcb.execute-api.us-east-1.amazonaws.com/default/funcHandleFetchDataRequest-dev";
// const FETCH_DATA_TEST_REST_API = "https://ui7k4euou4z24pvzt2on3lk2im0mukcf.lambda-url.us-east-1.on.aws";

const authConfig = () => ({
  headers: {
    "content-type": "application/json",
    Authorization: localStorage.getItem("GStoken"),
  },
});

const config = {
  headers: {
    "content-type": "application/json",
  },
};

export const createIntuitJobQueue = (realmId) => {
  return axios
    .post(`${FETCH_DATA_REST_API}?realmId=${realmId}&createQueue=true&fetchData=true`, {}, authConfig())
    .then((res) => {
    });
}

export const sendUserLogToAWS = async (realmId, logs) => {
  return axios
    .post(`${FETCH_DATA_REST_API}?realmId=${realmId}&userLogs=true`, {'userLogs':JSON.stringify(logs)}, authConfig())
    .then((res) => {
    });
}

export const createQBTokens = async (authCode, realmId) => {
  return axios
    .post(`${FETCH_DATA_REST_API}?target=Intuit&realmId=${realmId}&createTokens=true&authCode=${authCode}`, {}, authConfig())
    .then((res) => {
      return res.data;
    });
}

export const createQBUri = async () => {
  return axios
    .post(`${FETCH_DATA_REST_API}?oauthUri=true&target=Intuit`, {}, authConfig())
    .then((res) => {
      return res.data;
    });
}

export const revokeQBAccess = async (realmId) => {
  return axios
    .post(`${FETCH_DATA_REST_API}?target=Intuit&realmId=${realmId}&revoke=true`, {}, authConfig())
    .then((res) => {
      return res.data;
    });
}

export const createXeroTokens = async (authCode, state) => {
  return axios
    .post(`${FETCH_DATA_TEST_REST_API}?target=Xero&createTokens=true&authCode=${authCode}&state=${state}`, {}, authConfig())
    .then((res) => {
      return res.data;
    });
}

export const createXeroUri = async () => {
  // Lambda derives the redirect URI from the browser's Origin header
  // (validated against an allowlist server-side). The WAF blocks URLs
  // containing `http://localhost` when they appear in body or query.
  return axios
    .post(`${FETCH_DATA_TEST_REST_API}?target=Xero&oauthUri=true`, {}, authConfig())
    .then((res) => res.data);
}

export const revokeXeroAccess = async (realmId) => {
  return axios
    .post(`${FETCH_DATA_TEST_REST_API}?target=Xero&realmId=${realmId}&revoke=true`, {}, authConfig())
    .then((res) => {
      return res.data;
    });
}

export const triggerLoopEmailEvent = (eventName) => {
  return axios
    .post(`${FETCH_DATA_REST_API}?&triggerLoopEmails=true&eventName=${eventName}`, {}, authConfig())
    .then((res) => {
      return res.data;
    })
}

export const sendAwsLogin = () => {
  return axios
    .post(`${FETCH_DATA_REST_API}?login=web`, {}, authConfig())
    .then((res) => {
    });
};

export const manualCompanyRefresh = (realmId) => {
  return axios
    .post(`${FETCH_DATA_REST_API}?realmId=${realmId}&fetchData=true`, {}, authConfig())
    .then((res) => {

    });
};

export const getQBLoginRequest = (email, nextToken) => {
  return axios
    .post(url, { ...getQBLoginQuery(email, nextToken) }, authConfig())
    .then((res) => {
      return { 'items': res.data.data.listCompanys.items, 'nextToken': res.data.data.listCompanys.nextToken };
    });
};

export const getQBLoginByCompanyRequest = (email, realmId) => {
  return axios
    .post(
      url,
      { ...getQBLoginByCompanyQuery(email, realmId) },
      authConfig()
    )
    .then((res) => {
      return res.data.data.getCompany;
    });
};

export const updateQBLoginMutation = (email, realmId, idToken, accessToken, refreshToken) => {
  return axios
    .post(
      url,
      { ...updateQBLoginQuery(email, realmId, idToken, accessToken, refreshToken) },
      authConfig()
    )
    .then((res) => {
      return res.data;
    });
};

export const updateCompanySettingsMutation = (email, realmId, companyName, settings) => {

  return axios
    .post(
      url,
      { ...updateQBCompanySettings(email, realmId, companyName, settings) },
      authConfig()
    )
    .then((res) => {
      return res.data;
    });
}

export const createQBLoginMutation = (company) => {
  return axios
    .post(url, { ...createQBLoginQuery(company) }, authConfig())
    .then((res) => {
      return res.data;
    });
};

export const deleteQBLoginMutation = (email, realmId) => {
  return axios
    .post(url, { ...deleteQBLoginQuery(email, realmId) }, authConfig())
    .then((res) => {
      return res.data;
    });
};

export const createAccountRequest = (email) => {
  const lastActiveDate = moment.utc().format();
  return axios
    .post(url, { ...createAccountQuery(email, lastActiveDate) }, authConfig())
    .then((res) => {
      return res.data;
    });
};

export const updateAccountMutation = (email, tier) => {
  return axios
    .post(url, { ...updateAccountQuery(email, tier) }, authConfig())
    .then((res) => {
      return res.data;
    });
};

export const updateAccountDiscountMutation = (email, discount) => {
  return axios
    .post(url, { ...updateDiscountQuery(email, discount) }, authConfig())
    .then((res) => {
      return res.data;
    });
}

export const getAccount = (email) => {
  return axios
    .post(url, { ...getAccountQuery(email) }, authConfig())
    .then((res) => {
      return res.data;
    });
};

export const updateAccountActivity = (email) => {
  const lastActiveDate = moment.utc().format();
  return axios
    .post(url, { ...updateAccountActivityQuery(email, lastActiveDate) }, authConfig())
    .then((res) => {
      return res.data;
    });
}
